import { compose } from 'redux'
import { connect } from 'react-redux'
import { withFormik } from 'formik'
import * as yup from 'yup'
import { HACIENDA_PARSING_ERROR } from '../../../../../utils/exceptions/constants'
import { bindPromiseCreators } from '../../../../../utils/routines'
import {
  createHaciendaPromise
} from '../../../routines'
import { CSV_CODE } from '../Forms/validationMessages'

const mapDispatchToProps = bindPromiseCreators({ upload: createHaciendaPromise })
const connector = connect(null, mapDispatchToProps)

const formik = withFormik({
  mapPropsToValues: ({ model }) => ({
    code: '',
    model
  }),
  validationSchema: props => {
    let code = yup.string()
    if (props.mandatory) {
      code = code.required()
    }
    return yup.object().shape({
      code: code
        .matches(/^[a-zA-Z0-9]{16}$/, { message: CSV_CODE }),
      model: yup.string().required(),
    })
  },
  async handleSubmit(values, { props, setSubmitting, setStatus, resetForm }) {
    setStatus({ error: null })
    try {
      await props.upload({
        id: props.application.id,
        ...values
      })
      // for security reasons delete token
      // FIXME: if the component unmounts because is from other period
      // call setState on unmounted component...
      resetForm()

      if (props.onUploadSuccess) {
        props.onUploadSuccess(props.model, props.period)
        props.handleParsingError(props.model, 'remove')
      }
      // manage by redux
      // setStatus({ success: result })
      return
    } catch (error) {
      if (error.response.response.code === HACIENDA_PARSING_ERROR) {
        props.handleParsingError(props.model, 'add')
      }
      setStatus({ error })
    } finally {
      setSubmitting(false)
    }
  }
})

export default compose(
  connector,
  formik
)
